
import { Options, Vue } from 'vue-class-component';
import AppointmentsCalendar from "@/components/AppointmentsCalendar.vue";
import { Appointment } from "@/data/appointments";
import RegionService from "@/services/RegionService";
import CourseFilter from "@/components/filters/CourseFilter.vue";
import { Course } from "@/data/course";
import { CoursesFilterEvent } from "@/data/eventbus";
import { createSelectOptions } from "@/utils/array";
import { filterAppointments } from "@/utils/filter";
import EventBusService from "@/services/EventBusService";

@Options({
    components: {
        CourseFilter,
        AppointmentsCalendar,
    },
})
export default class App extends Vue {
    regionId: number|null = null

    loading = false
    loaded = false

    appointmentsRaw: Appointment[] = []

    currentFilterEvent: CoursesFilterEvent|null = null

    loadAppointments(): Promise<Appointment[]> {
        this.loading = true;
        return RegionService.getRegionAppointments(this.regionId as number).then(result => {
            this.appointmentsRaw = result.data.data || [];
            this.loaded = true;
            return this.appointmentsRaw;
        }).finally(() => this.loading = false);
    }

    get appointments(): Appointment[] {
        if( !this.currentFilterEvent ) {
            return this.appointmentsRaw;
        }

        return filterAppointments(this.appointmentsRaw, this.currentFilterEvent);
    }

    get filterCourseTypes() {
        const courses: Course[] = this.appointmentsRaw.filter(appointment => typeof appointment.course !== 'undefined').map(appointment => appointment.course) as Course[];

        return createSelectOptions(
            courses,
            (course: Course) => course.course_type.id,
            (course: Course) => course.course_type.name
        );
    }
    get filterLocations() {
        const courses: Course[] = this.appointmentsRaw.filter(appointment => typeof appointment.course !== 'undefined').map(appointment => appointment.course) as Course[];

        return createSelectOptions(
            courses.filter(course => typeof course.location !== 'undefined' && course.location),
            (course: Course) => course.location?.id || -1,
            (course: Course) => course.location?.name || ''
        );
    }

    filterSelectionChanged(event: CoursesFilterEvent): void {
        this.currentFilterEvent = {...event};
    }

    mounted(): void {
        const container = this.$el.parentNode;
        if( typeof container.dataset.regionId === 'undefined' ) {
            return console.error(`ShowCalendarRegion page component is missing parameter 'data-region-id'`);
        }
        this.regionId = parseInt(container.dataset.regionId);

        this.loadAppointments();

        EventBusService.$on('region.courses.filter:changed', this.filterSelectionChanged);
    }
    beforeUnmount() {
        EventBusService.$off('region.courses.filter:changed', this.filterSelectionChanged);
    }
}
